/*!
 * Copyright (c) 2026 GS Elektromedizinische Geraete G. Stemple GmbH, Germany - all rights reserved.
 * <p>
 * DO NOT ALTER OR REMOVE COPYRIGHT NOTICES OR THIS FILE HEADER.
 */

@use '../../../../variables';
@use '../../../../mixins';

.gcs-toggle {
  justify-content: flex-start;
  height: 45px;
  margin: variables.$padding-medium;

  button.MuiToggleButtonGroup-grouped {
    width: 51px;
  }
  .gcs-score {
    margin-left: variables.$margin-large;

    .title-content {
      padding: 0;
    }
  }
}

.gcs-row {
  gap: variables.$margin-large;
  > div {
    @include mixins.use-available-space;
    &.column {
      justify-content: space-between;
    }
  }
}
